import React from 'react';

import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import Close from '@telus-uds/palette-allium/build/web/icons/Close';

import request, { isAdmin, isOrderFulfillmentTeam } from '../../utils/request';
import { TagContainer } from './css';

const Tag = ({ orderId, tagKey, tagLabel, callback }) => {
  const canResetFlag = isAdmin || isOrderFulfillmentTeam;

  const resetTag = async () => {
    const result = await request.put(`/orders/${orderId}`, { [tagKey]: false });

    if (result && result.status === 200) callback();
  };
  return (
    <TagContainer>
      {tagLabel}
      {canResetFlag && (
        <div>
          <Button icon={Close} onPress={resetTag} accessibilityLabel="Close" variant={{ text: true }} />
        </div>
      )}
    </TagContainer>
  );
};

Tag.propTypes = {
  orderId: PropTypes.string.isRequired,
  tagKey: PropTypes.string.isRequired,
  tagLabel: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired
};

export default Tag;
